import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setDisplayLoader } from 'redux/app/appSlice';
import {
  setAccessToken,
  setAccessExpires,
  setLoginStatus,
  setSignupStatus,
  setForgotStatus,
  setResetStatus,
  resetAuth,
  setCheckOtpStatus,
} from 'redux/auth/authSlice';
import { resetUser } from 'redux/user/userSlice';
import { resetVps } from 'redux/vps/vpsSlice';
import { resetMonitoring } from 'redux/monitoring/monitoringSlice';
import { resetBalance } from 'redux/balance/balanceSlice';
import { resetPayment } from 'redux/payment/paymentSlice';
import { resetPartners } from 'redux/partners/partnersSlice';
import { resetSupport } from 'redux/support/supportSlice';
import { resetProfile } from 'redux/profile/profileSlice';

import { store } from 'redux/store'

import authService from 'services/authService';

const signup = credentials => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await authService.signup(credentials)
    dispatch(setSignupStatus('success'))
  } catch (e) {
    if (e.response?.status === 401) return

    if (e.response?.status === 422) {
      dispatch(setSignupStatus(e.response.data.message))
      return
    }

    Notify.failure(e.response?.data?.message || 'Request Signup failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const checkSignupOtp = data => async dispatch => {
  try {
    await authService.checkSignupOtp(data)

    dispatch(setCheckOtpStatus('success'))
  } catch (e) {
    if (e.response?.status === 401) return

    if (e.response?.status === 404 || e.response?.status === 422) {
      dispatch(setCheckOtpStatus(e.response.data.message))
      return
    }

    Notify.failure(e.response?.data?.message || 'Request CheckSignupOtp failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const login = credentials => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))

    const response = await authService.login(credentials)
    const { token, expires } = response.data

    dispatch(setAccessToken(token))
    dispatch(setAccessExpires(expires))
    dispatch(setLoginStatus('success'))
  } catch (e) {
    if (e.response?.status === 403 || e.response?.status === 401 || e.response?.status === 404) {
      dispatch(setLoginStatus(e.response.data.message))
      return
    }

    Notify.failure(e.response?.data?.message || 'Request Login failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const reset = () => async dispatch => {
  dispatch(resetVps())
  dispatch(resetMonitoring())
  dispatch(resetPartners())
  dispatch(resetBalance())
  dispatch(resetPayment())
  dispatch(resetSupport())
  dispatch(resetProfile())
  dispatch(resetUser())
  dispatch(resetAuth())
}

const logout = () => async dispatch => {
  try {
    await authService.logout()
    dispatch(reset())
    // Notify.success('Logout successful')
  } catch (e) {
    if (e.response?.status === 401) return
    Notify.failure(e.response?.data?.message || 'Request Logout failure')
  }
}

const refreshToken = async () => {
  const { dispatch, getState } = store; // direct access to redux store

  const { auth: { accessToken } } = getState()

  if (!accessToken) return

  try {
    const response = await authService.refreshToken()
    const { data: { token, expires } } = response

    dispatch(setAccessToken(token))
    dispatch(setAccessExpires(expires))
  } catch (e) {
    // если куки нет или просрочена - сброс приложения
    if (e.response?.status === 401) {
      dispatch(reset())
      return
    }

    Notify.failure(e.response?.data?.message || 'Request RefreshToken failure')
  }
}

const forgotPassword = email => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await authService.forgotPassword(email)
    dispatch(setForgotStatus('success'))
  } catch (e) {
    if (e.response?.status === 401) return

    if (e.response?.status === 422 && e.response?.data?.message) {
      dispatch(setForgotStatus(e.response.data.message))
      return
    }
    Notify.failure(e.response?.data?.message || 'Request ForgotPassword failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const checkForgotOtp = data => async dispatch => {
  try {
    await authService.checkForgotOtp(data)
    dispatch(setCheckOtpStatus('success'))
  } catch (e) {
    if (e.response?.status === 401) return

    if (e.response?.status === 400 && e.response?.data?.message) {
      dispatch(setCheckOtpStatus(e.response.data.message))
      return
    }

    Notify.failure(e.response?.data?.message || 'Request CheckForgotOtp failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

const passwordReset = credentials => async dispatch => {
  try {
    dispatch(setDisplayLoader(true))
    await authService.passwordReset(credentials)
    dispatch(setResetStatus('success'))
  } catch (e) {
    if (e.response?.status === 401) return
    if (e.response?.status === 400 && e.response?.data?.message?.detail) {
      dispatch(setResetStatus(e.response.data.message.detail))
      return
    }
    Notify.failure(e.response?.data?.message || 'Request PasswordReset failure')
  } finally {
    dispatch(setDisplayLoader(false))
  }
}

export default {
  signup,
  checkSignupOtp,
  login,
  logout,
  refreshToken,
  forgotPassword,
  checkForgotOtp,
  passwordReset,
  reset
}